import axios from 'axios';

// 動態獲取當前域名和協議
const getBaseURL = () => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  // 構建完整的 base URL
  let baseURL = `${protocol}//${hostname}`;
  if (port && port !== '80' && port !== '443') {
    baseURL += `:${port}`;
  }
  
  // 添加 ordersong API 路徑
  baseURL += '/ordersong/api';
  
  return baseURL;
};

const instance = axios.create({
  baseURL: getBaseURL(),
  timeout: 5000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 修改請求攔截器，移除強制 HTTPS 轉換
instance.interceptors.request.use(
  config => {
    console.log('Request:', config);
    return config;
  },
  error => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// 添加响应拦截器用于调试
instance.interceptors.response.use(
  response => {
    console.log('Response:', response);
    return response;
  },
  error => {
    if (error.response) {
      // 服務器回應了請求，但狀態碼不在 2xx 範圍內
      console.error('Response Error Data:', error.response.data);
      console.error('Response Error Status:', error.response.status);
      console.error('Response Error Headers:', error.response.headers);
    } else if (error.request) {
      // 請求已發出，但沒有收到回應
      console.error('Request Error:', error.request);
    } else {
      // 在設置請求時發生了錯誤
      console.error('Error Message:', error.message);
    }
    return Promise.reject(error);
  }
);

export default instance;